import Button from '../common/Button';

const WarningModal = ({ isOpen, tabSwitchCount, maxTabSwitches, onClose, onEnterFullscreen }) => {
  if (!isOpen) return null;
  const remaining = maxTabSwitches - tabSwitchCount;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm animate-fade-in">
      <div className="bg-slate-900 border border-red-500/40 rounded-2xl shadow-2xl max-w-sm w-full mx-4 p-7 text-center animate-scale-in">
        {/* Icon */}
        <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>

        <h2 className="text-lg font-bold text-red-400 mb-1">Tab Switch Detected</h2>
        <p className="text-slate-400 text-sm mb-4">You switched away from the exam window.</p>

        {/* Counter */}
        <div className="bg-red-500/10 border border-red-500/20 rounded-xl px-4 py-3 mb-4">
          <p className="text-red-300 text-sm font-semibold">
            Switch #{tabSwitchCount} of {maxTabSwitches}
          </p>
          {remaining > 0 ? (
            <p className="text-red-400 text-sm mt-1">
              <strong>{remaining} warning{remaining !== 1 ? 's' : ''}</strong> remaining before auto-submit
            </p>
          ) : (
            <p className="text-red-300 text-sm mt-1 font-bold">Exam will be submitted now!</p>
          )}
        </div>

        <p className="text-xs text-slate-500 mb-5">
          Tab switching is a violation of exam rules and is being logged.
        </p>

        <div className="flex flex-col gap-2">
          <Button onClick={onEnterFullscreen} fullWidth>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
            </svg>
            Re-enter Fullscreen &amp; Continue
          </Button>
          <Button variant="ghost" onClick={onClose} fullWidth>
            Continue Without Fullscreen
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WarningModal;
